enum ReadingPanePosition {
    Off = 0,
    Right = 1,
    Bottom = 2,
    Popout = 3
}

export default ReadingPanePosition;
